export const NAMESPACE_SVG_URI = 'http://www.w3.org/2000/svg';

// CLASSES
export const LIB_CLASS_PREFIX = 'inclusive-dates';
export const COMPONENT_CLASS = 'inclusive-datepicker';
export const CALENDAR_CLASS = `${LIB_CLASS_PREFIX}__calendar`;
export const CALENDAR_BUTTON_CLASS = `${CALENDAR_CLASS}-button`;
export const CALENDAR_BUTTON_ERROR_CLASS = `${CALENDAR_BUTTON_CLASS}--error`;
export const CALENDAR_ICON_CLASS = `${CALENDAR_CLASS}-icon`;
export const MISSING_TAGOFF_ICON_CLASS = `${LIB_CLASS_PREFIX}__missing-tag-off-icon`;
export const INPUT_CLASS = `${LIB_CLASS_PREFIX}__input`;
export const INPUT_ERROR_CLASS = `${INPUT_CLASS}-error`;

// SELECTORS
export const COMPONENTS_SELECTOR = `.${COMPONENT_CLASS}`;
export const CALENDAR_BUTTON_SELECTOR = `.${CALENDAR_BUTTON_CLASS}`;
export const INPUT_SELECTOR = `.${INPUT_CLASS}`;
export const CALENDAR_DATE_SELECTOR = `.${LIB_CLASS_PREFIX}-calendar__date.sc-inclusive-dates-calendar`;
export const CALENDAR_FOOTER_BUTTONS_SELECTOR = `.${LIB_CLASS_PREFIX}-calendar__footer.sc-${LIB_CLASS_PREFIX}-calendar > div > button`;
